(() => {
  const section = document.getElementById(document.currentScript?.dataset.section);
  if (!section || section.dataset.kmOnesieSizeOrder) return;
  section.dataset.kmOnesieSizeOrder = 'true';

  const reorderSizes = () => {
    if (!section.querySelector('[data-customizer][data-product-id="10262051553472"], [data-customizer][data-product-id="7398300385472"], [data-customizer][data-product-id="7525593612480"], [data-customizer][data-product-id="7516062286016"]')) return;
    const grid = section.querySelector('.customizer__size-quantity-grid');
    if (!grid) return;
    const newborn = Array.from(grid.children).find(label =>
      label.querySelector('span')?.textContent.trim().toLowerCase() === 'newborn'
    );
    // Move the existing control so its value, listeners and keyboard order stay intact.
    // Leave Shopify's variant selection and product option ordering unchanged.
    if (newborn && grid.firstElementChild !== newborn) grid.prepend(newborn);
  };

  const observer = new MutationObserver(reorderSizes);
  observer.observe(section, { childList: true, subtree: true });
  reorderSizes();
})();
